import { useMutation } from "react-apollo"
import gql from "graphql-tag"
import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"

const TOGGLE_BUILD_CHECKS = gql`
  mutation toggleBuilds($siteId: UUID!) {
    toggleBuildChecks(siteId: $siteId) {
      success
      message
    }
  }
`

export default function useToggleBuildChecks(siteId) {
  const [toggleBuildChecksMutation, { loading }] = useMutation(
    TOGGLE_BUILD_CHECKS
  )
  const [setError, errorAlert] = useTriggerErrorAlert()

  const toggleBuildChecks = () => {
    setError(null)
    return toggleBuildChecksMutation({
      variables: {
        siteId,
      },
      update: updateBuildChecksEnabledCache(siteId),
      optimisticResponse: {
        toggleBuildChecks: {
          success: true,
          message: null,
          __typename: `MutationResult`,
        },
      },
    }).catch(err => setError(err))
  }

  return [toggleBuildChecks, { loading, errorAlert }]
}

function updateBuildChecksEnabledCache(siteId) {
  return (proxy, { data }) => {
    if (!data.toggleBuildChecks.success) {
      return
    }
    const fragmentInfo = {
      id: `Site:${siteId}`,
      fragment: gql`
        fragment siteDetailsBuildChecksFrag on Site {
          id
          buildChecksEnabled
        }
      `,
    }

    const site = proxy.readFragment(fragmentInfo)

    site.buildChecksEnabled = !site.buildChecksEnabled

    proxy.writeFragment({
      ...fragmentInfo,
      data: site,
    })
  }
}
